// begin
export const OPEN_FILE_LOCAL                  = 'open-local-file';
export const OPEN_FILE_FROM_URL               = 'open-from-url';                     //'fv--open-fromurl-button'
export const OPEN_FILE_FROM_GOOGLE_DRIVE      = 'open-file-from-google-drive';
export const OPEN_FILE_FROM_IMANAGE           = 'open-file-from-imanage';
export const OPEN_FILE_FROM_DROPBOX           = 'open-fie-from-dropbox';
export const OPEN_FILE_FROM_BOX               = 'open-file-from-box';
export const OPEN_FILE_FROM_ONE_DRIVE         = 'open-file-from-one-drive';
export const OPEN_FILE_FROM_DRIVES            = 'open-file-from-drives';
export const OPEN_FILE_FROM_PRIVATE_DRIVE     = 'open-file-from-private-drive';
export const OPEN_FILE_FROM_PRIVATE_DRIVE_S3  = 'open-file-from-private-drive-s3';
export const OPEN_FILE_FROM_PRIVATE_DRIVE_NFS = 'open-file-from-private-drive-nfs';
export const OPEN_FILE_FROM_GET_START_GUID    = 'open_file_from_get_start_guid';
export const OPEN_FILE_FROM_RECENT            = 'open-file-from-recent';
export const OPEN_FILE_FROM_DOCUMENTS         = 'open-file-from-documents';
export const DOUBLE_CLICK_TO_OPEN_LOCAL_FILES = 'double_click_to_open_local_files';
// end
export const OPEN_URL_CLASS = 'fv__icon-toolbar-open-url';
export const OPEN_GOOGLE_CLASS = 'fv__icon-toolbar-open-google';
export const OPEN_IMANAGE_CLASS = 'fv__icon-toolbar-open-imanage'
export const OPEN_ONE_DRIVE_CLASS = 'fv__icon-toolbar-open-one-drive';
export const OPEN_BOX_CLASS = 'fv__icon-toolbar-open-box';
export const OPEN_DROP_BOX_CLASS = 'fv__icon-toolbar-open-drop-box';
export const OPEN_DRIVES_CLASS = 'fv__icon-toolbar-open-drives'
export const OPEN_PRIVATE_DRIVE_CLASS = 'fv__icon-toolbar-open-private-drive';
export const OPEN_PRIVATE_DRIVE_S3_CLASS = 'fv__icon-toolbar-open-private-drive-s3';
export const OPEN_PRIVATE_DRIVE_NFS_CLASS = 'fv__icon-toolbar-open-private-drive-nfs';
